import type React from 'react';
import Linker from 'app/shared/modules/Linker';
import { yieldCallback } from '@zillow/yield-callback';
import { getMenuItemCX, menuItemLinkCX } from 'app/shared/modules/navigation/header/headerNavMenuItem.styles';

interface HeaderNavMenuItemProps {
  active?: boolean;
  escape?: boolean;
  mainLinkUrl?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const HeaderNavMenuItem: React.FC<HeaderNavMenuItemProps> = ({ active, escape, mainLinkUrl, children, onClick }) => {
  const yieldTransitionTo = yieldCallback((url: string) => {
    window.router.transitionTo(url);
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (escape) {
      return;
    }

    if (onClick) {
      onClick();
      return;
    }

    e.preventDefault();
    if (mainLinkUrl) {
      yieldTransitionTo(mainLinkUrl);
    }
  };

  // Strip query parameters for clean hover URLs
  const displayUrl = (mainLinkUrl || '').split('?')[0];

  return (
    <li className={getMenuItemCX(active)}>
      <Linker
        disabled={active}
        className={menuItemLinkCX}
        escape={escape}
        to={displayUrl}
        onClick={handleClick}
        linkType="inherit"
      >
        {children}
      </Linker>
    </li>
  );
};

export default HeaderNavMenuItem;
